export const sxStyle = {
  bestPriceAirContainerCustom: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignSelf: 'center',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    padding: { xs: '21px 41px', sm: '0' },
    marginBottom: { xs: 0, sm: '-1vh' },
  },
  bestPriceAirCardsContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    padding: '1rem',
    textAlign: 'center',
    flexDirection: { xs: 'column', sm: 'row' },
  },
};
